module.exports = __webpack_public_path__ + "img/LUB00014.ab940632.png";